import { render, staticRenderFns } from "./DateBirthdayField.vue?vue&type=template&id=0391c78e&"
import script from "./DateBirthdayField.vue?vue&type=script&lang=js&"
export * from "./DateBirthdayField.vue?vue&type=script&lang=js&"
import style0 from "./DateBirthdayField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports